module.exports = __webpack_public_path__ + "img/wip.e732a286.svg";